import styled from "styled-components";
import { ToggleButton } from "@/ui";

export const StyledScreenShareToggleButton = styled(ToggleButton)<{
  $active: boolean;
}>`
  ${({ $active }) => $active ? 'background-color: var(--color-text-80);' : ''}
`;
